import { Button, ButtonGroup, Container, Dropdown, Nav, NavDropdown, Navbar } from "react-bootstrap";
import '../styles/navbar.scss'
import { Link } from "react-router-dom";
import config from '../config/config.json';
import { BrightnessHigh, List, MoonStarsFill } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import $ from 'jquery';

export default function Header(props){
    const [selectedLang, setSelectedLang] = useState('en');

    const { i18n, t } = useTranslation();

    const languageChange = (evtKey) => {
        setSelectedLang(evtKey);
        i18n.changeLanguage(evtKey);
    }

    const switchTheme = (e)=>{
        e.preventDefault();
        const theme = $("body").attr('data-theme');
        console.log(theme);
        $("body").removeAttr('data-theme');
        if(theme === 'dark'){
            props.onThemeChange('light');
            $("body").attr('data-theme','light');
            $('.theme-switch.light').show();
            $('.theme-switch.dark').hide();
        }
        else if(theme === 'light'){
            props.onThemeChange('dark');
            $("body").attr('data-theme','dark');
            $('.theme-switch.dark').show();
            $('.theme-switch.light').hide();
        }
    }
    const openMailTo = () => {
        window.open("mailto:bsindiahr@sella.it");
    }

    return(
        <Navbar collapseOnSelect expand="lg" className="custom-navbar">
            <Container>
                <Navbar.Brand>
                    <Link to='/'>
                        <div className="centrico-logo-placeholder"></div>
                    </Link>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav">
                    <List/>
                </Navbar.Toggle>
                <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-center header-navigations">
                    <Nav className="me-auto">
                        <NavDropdown title={t('header.menu.whoweare')} id="collapsible-nav-dropdown">
                            {config['header']['menu']['whoweare'].map((item, id) => {
                                return (<NavDropdown.Item key={id} as={Link} to={item.path}>{t(`header.menu.${item.id}`)}</NavDropdown.Item>)
                            })}
                        </NavDropdown>
                        <NavDropdown title={t('header.menu.whatwedo')} id="collapsible-nav-dropdown">
                            {config['header']['menu']['whatwedo'].map((item, id) => {
                                return (<NavDropdown.Item key={id} as={Link} to={item.path}>{t(`header.menu.${item.id}`)}</NavDropdown.Item>)
                            })}
                        </NavDropdown>
                        <NavDropdown title={t('header.menu.lifeatcentrico')} id="collapsible-nav-dropdown">
                            {config['header']['menu']['lifeatcentrico'].map((item, id) => {
                                return (<NavDropdown.Item key={id} as={Link} to={item.path}>{t(`header.menu.${item.id}`)}</NavDropdown.Item>)
                            })}
                        </NavDropdown>
                    </Nav>
                </Navbar.Collapse>
                <Navbar.Collapse className="justify-content-end">
                    <div className="header-actions">
                        <ul className="navigasi-list">
                            <li>
                                <button type="button" className="btn theme-switch dark" onClick={switchTheme}><BrightnessHigh/></button>
                                <button type="button" className="btn theme-switch light" onClick={switchTheme}><MoonStarsFill/></button>
                            </li>
                            {/* <li>
                                <Dropdown as={ButtonGroup} onSelect={languageChange}>
                                    <Button variant="success" className={`selection ${selectedLang}`}>{selectedLang.toUpperCase()}</Button>
                                    <Dropdown.Toggle split variant="success" id="dropdown-split-basic" />
                                    <Dropdown.Menu>
                                        {config['header']['languages'].map((item, id) => {
                                            return (<Dropdown.Item key={id} eventKey={item.code} active={item.code === selectedLang}>{item.lang} ({item.code.toUpperCase()})</Dropdown.Item>)
                                        })}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </li> */}
                            <li>
                                <button type="button" className="btn c-button c-gradient c-btn-contactus" onClick={openMailTo}>{t("header.contactus")}</button>
                            </li>
                        </ul>
                    </div>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}